import { useContext } from 'react';
import { ContextType } from './interfaces'
import { UserContext } from './UserContext';

function AdminLevel({ level, match, children }: { level: number, match: string, children: any }) {
    const { currentUser, setCurrentUser } = useContext(UserContext) as ContextType;

    switch (match) {
        case 'equal':
            if (currentUser.adminLevel === level) {
                return children
            }
            break;
        case 'greater':
            if (currentUser.adminLevel > level) {
                return children
            }
            break;
        case 'greaterOrEqual':
            if (currentUser.adminLevel >= level) {
                return children
            }
            break;
    }
    return null
}

export default AdminLevel
